/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { Button } from 'react-bootstrap';
import SVGComponent from '../../../../../SharedModules/SVGComponents/SVGComponents';

const TransitionDataActionButtons = ({ onButtonClick, disabled }) => {
  const clickHandler = (event) => onButtonClick(event.target.name);
  return (
    <>
      <div className='col-sm-8 pl-0'>
        <div className='btn-wrapper mb-2'>
          <div className='mt-2 hide-on-print'>
            <Button
              name='N'
              className='btn-success same-font-family'
              onClick={clickHandler}
              disabled={disabled}
            >
              <SVGComponent iconName='Icon-run-now' /> Run Now
            </Button>
            <Button
              name='L'
              className='btn-success same-font-family'
              onClick={clickHandler}
              disabled={disabled}
            >
              <SVGComponent iconName='Icon-run-later' /> Run Later
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default TransitionDataActionButtons;
